import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import RefundHeader from './components/RefundHeader';
import RefundButtons from './components/RefundButtons';
import RefundInfo from './components/RefundInfo';
import StateRefundGrid from './components/StateRefundGrid';
import TaxPartners from './components/TaxPartners';
import PartnersCarousel from './components/PartnersCarousel';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '40px',
  },
}));

const WhereIsMyRefundPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav/>
      <PageHeaders
        title="Where's My Tax Refund? IRS Status Guide + How to Invest It | Plootus"
        description="Check your IRS tax refund status and learn how to put your refund to work for retirement. Plootus links to the official IRS tracker and shows you how investing your refund in a 401k or IRA maximizes long-term growth."
        keywords="tax refund, where is my refund, IRS refund, state tax refund, amended return status"
        ogTitle="Where's My Tax Refund? — Track It + Invest It Wisely | Plootus"
        ogDescription="Check your IRS tax refund status and learn how to put your refund to work for retirement. Plootus links to the official IRS tracker and shows you how investing your refund in a 401k or IRA maximizes long-term growth."
        ogUrl="https://www.plootus.com/where-is-my-refund"
        canonicalUrl="https://www.plootus.com/where-is-my-refund"
      />
      
      <RefundHeader />
      <RefundButtons />
      <RefundInfo />
      <TaxPartners />
      <PartnersCarousel />
      <StateRefundGrid />
    </div>
  );
};

export default WhereIsMyRefundPage;
